<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-row class="mt-1">
            <v-col cols="12" sm="5">
                <h4>{{ $t('Nuevo complemento') }}</h4>
                <v-card>
                    <v-form @submit.prevent="registerComplement" ref="form" lazy-validation>
                        <v-card-text class="pb-0">
                            <v-text-field
                                :label="$t('Título *')"
                                placeholder="Ej. ensaladas"
                                dense
                                outlined
                                v-model="title"
                                :rules="[rules.required]"
                            ></v-text-field>

                            <div v-if="typeStore != 'product'">
                                <label>{{ $t('Tipo de selección') }}</label>
                                <v-radio-group
                                    v-model="type"
                                    :rules="[rules.required]"
                                    class="mt-0"
                                    row
                                >
                                    <v-radio
                                        :label="$t('Selección multiple')"
                                        value="multiple"
                                    ></v-radio>
                                    <v-radio
                                        :label="$t('Selección de una sola opción')"
                                        value="only"
                                    ></v-radio>
                                </v-radio-group>
                            </div>
                            
                            <div v-if="typeStore != 'product'">
                                <div v-if="type=='multiple'">
                                    <label>{{ $t('Selección de cantidades') }}</label>
                                    <v-switch
                                        v-model="isQuantity"
                                        class="mt-0"
                                        :label="`${(isQuantity)?$t('inhabilitar'):' '+$t('habilitar')} ${$t('cantidades')}`"
                                    ></v-switch>
                                </div>
                                <label>{{ $t('Cantidades') }}</label>
                                <v-switch
                                    v-model="quantities"
                                    class="mt-0"
                                    :label="$t('Afectar a cantidades')"
                                ></v-switch>
                                <label>{{ $t('Campo requerido') }}</label>
                                <v-switch
                                    v-model="isRequired"
                                    class="mt-0"
                                    :label="`${$t('Campo')}: ${(isRequired) ? $t('obligatorio'): $t('no obligatorio')}`"
                                ></v-switch>
                            </div>

                            <div v-if="typeStore == 'product'">
                                <label>{{ $t('Campo requerido') }}</label>
                                <v-switch
                                    v-model="isRequired"
                                    class="mt-0"
                                    :label="`${$t('Campo')}: ${(isRequired) ? $t('obligatorio'): $t('no obligatorio')}`"
                                ></v-switch>
                            </div>

                            <div>
                                <div class="text-subtitle">{{ $t('Complementos') }}</div>
                                <v-divider class="mb-2"></v-divider>
                                <v-row no-gutters class="mb-2" align="center" v-for="(complement, k) in complements" :key="k">
                                    <v-col cols="5">
                                        <v-text-field
                                            :label="$t('Nombre *')"
                                            outlined
                                            dense
                                            hide-details
                                            :rules="[rules.required]"
                                            v-model="complement.name"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            :label="$t('Precio *')"
                                            outlined
                                            type="number"
                                            dense
                                            hide-details
                                            :rules="[rules.required]"
                                            v-model="complement.price"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="3" class="text-right" v-if="complements.length > 1">
                                        <v-btn color="error" icon text @click="()=>{complements.splice(k, 1)}">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-btn class="mt-3" dark small @click="()=>{complements.push({name: '', price: '', available: 1})}">{{ $t('Nuevo') }}</v-btn>
                            </div>
                            <div class="mt-5" v-if="type=='multiple'">
                                <v-text-field
                                    :label="$t('Selección máxima')"
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    step="1"
                                    :max="complements.length"
                                    v-model="selectMax"
                                    :rules="[rules.required]"
                                    @blur="()=>{if(selectMax>complements.length)selectMax=complements.length}"
                                ></v-text-field>
                                <v-text-field
                                    :label="$t('Cantidad máxima total')"
                                    :hint="$t('Cantidad máxima de todos los complementos juntos, vacío sin límite')"
                                    persistent-hint
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    step="1"
                                    v-model="selectQuantity"
                                ></v-text-field>
                            </div>
                        </v-card-text>
                        <v-card-actions>
                            <v-card-text class="text-right">
                                <v-btn color="primary" type="submit">{{ $t('Guardar') }}</v-btn>
                            </v-card-text>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
            <v-col cols="12" sm="7">
                <h4>{{ $t('Complementos') }}</h4>
                <v-card>
                    <v-card-text>
                        <div>
                            <v-text-field
                                :label="$t('Buscar')"
                                outlined
                                dense
                                v-model="search"
                                clearable
                            ></v-text-field>
                        </div>
                        <draggable
                            :list="filteredListComplements"
                            :disabled="!enabled"
                            class="list-group"
                            ghost-class="ghost"
                            :move="checkMove"
                            @start="dragging = true"
                            @end="dragging = false"
                        >
                            <div
                                class="list-group-item"
                                v-for="element in filteredListComplements"
                                :key="element.id"
                            >
                                <div class="row align-center">
                                    <div class="col-8">
                                        <v-edit-dialog
                                            :return-value.sync="element.title"
                                            @save="save(element.id, element.title, element.type, element.complements, element.required, element.select, element.quantity, element.quantities, element.select_quantity)"
                                            @cancel="cancel"
                                            large
                                            persistent
                                        > {{ element.title }}
                                            <template v-slot:input>
                                                <v-card-text class="px-0">
                                                    <v-text-field
                                                        label="Título *"
                                                        placeholder="Ej. ensaladas"
                                                        dense
                                                        outlined
                                                        v-model="element.title"
                                                        :rules="[rules.required]"
                                                    ></v-text-field>
                                                    <div v-if="typeStore != 'product'">
                                                        <label>{{ $t('Tipo de selección') }}</label>
                                                        <v-radio-group
                                                            v-model="element.type"
                                                            :rules="[rules.required]"
                                                            class="mt-0"
                                                            row
                                                        >
                                                            <v-radio
                                                                :label="$t('Selección multiple')"
                                                                value="multiple"
                                                            ></v-radio>
                                                            <v-radio
                                                                :label="$t('Selección de una sola opción')"
                                                                value="only"
                                                            ></v-radio>
                                                        </v-radio-group>
                                                    </div>
                                                    <div v-if="typeStore != 'product'">
                                                        <div v-if="element.type=='multiple'">
                                                            <label>{{ $t('Selección de cantidades') }}</label>
                                                            <v-switch
                                                                v-model="element.quantity"
                                                                class="mt-0"
                                                                :label="`${(element.quantity)?$t('inhabilitar'):' '+$t('habilitar')} ${$t('cantidades')}`"
                                                            ></v-switch>
                                                        </div>
                                                        <label>{{ $t('Cantidades') }}</label>
                                                        <v-switch
                                                            v-model="element.quantities"
                                                            class="mt-0"
                                                            :label="$t('Afectar a cantidades')"
                                                        ></v-switch>
                                                        <label>{{ $t('Campo requerido') }}</label>
                                                        <v-switch
                                                            v-model="element.required"
                                                            class="mt-0"
                                                            :label="`${$t('Campo')}: ${(element.required)? $t('obligatorio'): $t('no obligatorio')}`"
                                                        ></v-switch>
                                                    </div>
                                                    <div v-if="typeStore == 'product'">
                                                        <label>{{ $t('Campo requerido') }}</label>
                                                        <v-switch
                                                            v-model="element.required"
                                                            class="mt-0"
                                                            :label="`${$t('Campo')}: ${(element.required)? $t('obligatorio'): $t('no obligatorio')}`"
                                                        ></v-switch>
                                                    </div>
                                                    <div>
                                                        <div class="text-subtitle">{{ $t('Complementos') }}</div>
                                                        <v-divider class="mb-2"></v-divider>
                                                        <v-row no-gutters class="mb-2" align="center" v-for="(complement, k) in element.complements" :key="k">
                                                            <v-col cols="4">
                                                                <v-text-field
                                                                    :label="$t('Nombre *')"
                                                                    outlined
                                                                    dense
                                                                    hide-details
                                                                    :rules="[rules.required]"
                                                                    v-model="complement.name"
                                                                ></v-text-field>
                                                            </v-col>
                                                            <v-col cols="4">
                                                                <v-text-field
                                                                    :label="$t('Precio *')"
                                                                    outlined
                                                                    type="number"
                                                                    dense
                                                                    hide-details
                                                                    :rules="[rules.required]"
                                                                    v-model="complement.price"
                                                                ></v-text-field>
                                                            </v-col>
                                                            <v-col cols="2">
                                                                <v-switch
                                                                    v-model="complement.available"
                                                                    :label="`${(complement.available)? 'Disponible' : 'No disponible'}`"
                                                                    :true-value="1"
                                                                    :false-value="0"
                                                                    hide-details
                                                                ></v-switch>
                                                            </v-col>
                                                            <v-col cols="2" class="text-right" v-if="element.complements.length > 1">
                                                                <v-btn color="error" icon text @click="()=>{element.complements.splice(k, 1)}">
                                                                    <v-icon>mdi-close</v-icon>
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                        <v-btn class="mt-3" dark small @click="()=>{element.complements.push({name: '', price: ''})}">{{ $t('Nuevo') }}</v-btn>
                                                    </div>
                                                    <div class="mt-5" v-if="element.type=='multiple'">
                                                        <v-text-field
                                                            :label="$t('Selección máxima')"
                                                            outlined
                                                            dense
                                                            type="number"
                                                            min="1"
                                                            step="1"
                                                            :max="element.complements.length"
                                                            v-model="element.select"
                                                            :rules="[rules.required]"
                                                            @blur="()=>{if(element.select>element.complements.length)element.select=element.complements.length}"
                                                        ></v-text-field>
                                                        <v-text-field
                                                            :label="$t('Cantidad máxima total')"
                                                            :hint="$t('Cantidad máxima de todos los complementos juntos, vacío sin límite')"
                                                            persistent-hint
                                                            outlined
                                                            dense
                                                            type="number"
                                                            min="1"
                                                            step="1"
                                                            v-model="element.select_quantity"
                                                        ></v-text-field>
                                                    </div>
                                                </v-card-text>
                                            </template>
                                        </v-edit-dialog>
                                    </div>
                                    <div class="col-4 text-right">
                                        <v-btn icon @click="deleteComplements(element.id)">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </div>
                                </div>
                                <v-divider></v-divider>
                            </div>
                        </draggable>
                    </v-card-text>
                </v-card>
                <!-- <div class="text-right mt-5">
                    <v-btn outlined @click="upOrderCat">
                        Actualizar Orden
                    </v-btn>
                </div> -->
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import draggable from 'vuedraggable'

export default {
    components: {
        draggable,
    },
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    href: '/admin/dashboard',
                },
                {
                    text: 'Mis complementos',
                    disabled: true,
                    href: '',
                }
            ],
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido'
            },
            errors: {},
            // fields
            title: '',
            type: 'only',
            quantities: true,
            isRequired: false,
            isQuantity: false,
            complements: [{name: '', price: 0, available: 1}],
            selectMax: null,
            selectQuantity: null,
            dialogScan: false,
            headers: [
                { text: 'Nombre', sortable: false, value: 'name' },
                { text: '', sortable: false, value: 'actions', align: 'end' }
            ],
            listComplements: [],
            search: '',
            // drag
            enabled: false,
            list: [
                { name: "John", id: 0 },
                { name: "Joao", id: 1 },
                { name: "Jean", id: 2 }
            ],
            dragging: false
        }
    },
    props: ['typeStore'],
    computed: {
        filteredListComplements() {
            const term = (this.search || '').trim().toLowerCase()
            if (term.length < 1) {
                return this.listComplements
            }
            return this.listComplements.filter((element) => {
                if ((element.title || '').toLowerCase().includes(term)) {
                    return true
                }
                const comps = element.complements || []
                return comps.some((c) =>
                    String(c.name || '').toLowerCase().includes(term)
                )
            })
        },
    },
    created() {
        this.getComplements();
    },
    methods: {
        async getComplements() {
            this.listComplements = []
            await axios.post('/admin/list-complements', {})
            .then(response => {
                // console.log(response);
                response.data.forEach(element => {
                    element.complements = JSON.parse(element.values)
                    this.listComplements.push(element)
                });
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },
        async registerComplement () {
            if (this.$refs.form.validate()) {
                this.errors = {}
                this.loading = true

                const formData = new FormData()
                formData.append('title', this.title);
                formData.append('type', this.type);
                formData.append(`complements`, JSON.stringify(this.complements));
                formData.append(`quantities`, (this.quantities)?1:0);
                formData.append(`required`, (this.isRequired)?1:0);
                formData.append(`quantity`, (this.isQuantity)?1:0);
                formData.append(`select`, this.selectMax);
                formData.append(`select_quantity`, (this.type=='multiple' && this.selectQuantity) ? this.selectQuantity : '');
                await axios.post('/admin/complements', formData)
                .then(response => {
                    // console.log(response);
                    if (response.data === 'ok') {
                        this.$alert('', this.$t('Complemento registrado con éxito.'), 'success', {confirmButtonText: this.$t('Continuar')})
                        // this.nameCat = ''
                        this.$refs.form.resetValidation()
                        this.$refs.form.reset()
                        this.complements = [{name: '', price: 0}]
                        this.getComplements();
                    }

                    this.loading = false
                })
                .catch(error => {
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                    }
                    this.loading = false
                })
            }
        },
        save (id, title, type, complements, required, select, quantity, quantities, selectQuantity) {
            const formData = new FormData
            formData.append('title', title);
            formData.append('type', type);
            formData.append(`complements`, JSON.stringify(complements));
            formData.append(`quantities`, (quantities)?1:0);
            formData.append(`required`, (required)?1:0);
            formData.append(`quantity`, (quantity)?1:0);
            formData.append(`select`, select);
            formData.append(`select_quantity`, (type=='multiple' && selectQuantity) ? selectQuantity : '');
            formData.append('_method', 'PUT')
            axios.post(`/admin/complements/${id}`, formData)
            .then(response => {
                // console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success(this.$t('Complemento actualizada con éxito.'));
                    this.nameCat = ''
                    this.getComplements();
                }
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.getComplements();
            })
        },
        cancel () {
            this.$notify.info(this.$t('Cancelado.'));
        },
        async deleteComplements (id) {
            if (confirm(this.$t('Eliminar complemento. ¿Desea continuar?'))) {
                await axios.delete(`/admin/complements/${id}`)
                .then(response => {
                    // console.log(response);
                    if (response.data === 'ok') {
                        this.$notify.success(this.$t('Complemento eliminado con éxito.'));
                        this.getComplements();
                    }
                })
                .catch(error => {
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert(this.$t('Error, es posible que tenga productos registrados con esta categoría.'));
                    }
                })
            }
        },
        // order
        checkMove: function(e) {
            window.console.log("Future index: " + e.draggedContext.futureIndex);
        },
        upOrderCat () {
            const formData = new FormData()
            for (let index = 0; index < this.listComplements.length; index++) {
                formData.append(`order[]`, this.listComplements[index].id)
            }
            axios.post(`/admin/update-order-complets`, formData)
            .then(response => {
                // console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success(this.$t('El orden de los complementos fue actualizado con éxito.'));
                    this.getComplements();
                }
            })
            .catch(error => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        }
    },
}
</script>
<style lang="scss">
    .list-group-item {
        cursor: pointer;
    }
</style>
